import React, { Component, Fragment } from 'react';
import classes from 'classnames';

import { IFRAME_ID } from 'helpers/constants';

class IframePreviewComponent extends Component {
  render() {
    const { src, domainClass, ...props } = this.props;

    return (
      <Fragment>
        <iframe
          id={IFRAME_ID}
          src={src}
          className={classes('iframe-phone', { domainClass })}
          frameBorder="0"
          width="100%"
          height="100%"
          allowFullScreen
          title="phone"
          {...props}
        />
      </Fragment>
    );
  }
}

export default IframePreviewComponent;



// WEBPACK FOOTER //
// ./src/components/IframePreviewComponent/IframePreviewComponent.js